import { Action } from "../../enums/action";
import { ErrorMessage } from "../../enums/error-message";
import { ValidationError } from "../validation-error";
import { SnakeCaseValidator } from "./snake-case-validator";
export class ActionValidator {
    snakeCaseValidator;
    constructor() {
        this.snakeCaseValidator = new SnakeCaseValidator();
    }
    validate(trackingData) {
        const action = trackingData.action;
        if (typeof action === 'undefined')
            return;
        if (!Object.values(Action).includes(action)) {
            throw new ValidationError(ErrorMessage.INVALID_ACTION);
        }
        this.snakeCaseValidator.validate(action);
    }
}
